import React, {Fragment} from "react";
import { Buffer } from "buffer";
import { environment } from "../../utils/environment";

//TODO: Remove the redirects comments
export default class LoginGuard extends React.PureComponent {
  componentDidMount(): void {
    const token = localStorage.getItem("AccessToken");
    if (!token) {
      const authData = environment.auth;
      const clientId = encodeURIComponent(authData.clientId);
      const redirectUrl = encodeURIComponent(authData.redirectUrl);
      const state = encodeURIComponent(
        Buffer.from(
          JSON.stringify({
            url: window.location.href
          })
        ).toString("base64")
      );
      const url = decodeURIComponent(`${environment.auth.baseUrl}/?clientId=${clientId}&redirectUrl=${redirectUrl}&state=${state}`);
      window.location.href = url;
    }
  }

  render() {
    return (<Fragment />);
  }
}

export function logout(){
  localStorage.removeItem("AccessToken");
  localStorage.removeItem("RefreshToken");
  localStorage.removeItem("ShoppingCart");
  const authData = environment.auth;
  const clientId = encodeURIComponent(authData.clientId);
  const redirectUrl = encodeURIComponent(authData.redirectUrl);
  const url = decodeURIComponent(`${environment.auth.baseUrl}/logout?clientId=${clientId}&redirectUrl=${redirectUrl}`);
  window.location.href = url;
}
